/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {

	jQuery('.videobox').mouseover(function() {
		jQuery('#videobox').addClass('active');
		jQuery('.fixpagehead .wpb_text_column').addClass('dark');
	});
	jQuery('.videobox').mouseout(function() {
		jQuery('#videobox').removeClass('active');
		jQuery('.fixpagehead .wpb_text_column').removeClass('dark');
	});

	jQuery('.videobox').click(function() {
		if(jQuery('#videobox').hasClass('active')){
			jQuery('#videobox').removeClass('active');
			jQuery('.fixpagehead .wpb_text_column').addClass('dark');
		}else{
			jQuery('#videobox').addClass('active');
			jQuery('.fixpagehead .wpb_text_column').removeClass('dark');
		}
	});

	jQuery('.frageantwortwrap').click(function() {
		jQuery(this).toggleClass('active');
	});




	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});


	//scroll menue einblendung
	jQuery(window).scroll(function() {
		var height = jQuery(window).scrollTop();

		if ((height > 15)) {
			jQuery('.flybar-wrap').addClass('active');
		} else {
			jQuery('.flybar-wrap').removeClass('active');
		}
	});


	/*jQuery( ".wc-block-components-checkout-place-order-button" ).on( "click", function() {
		setCookie('haschecktout','1',1);
	} ); */

	jQuery(document).on('click', function(e) {
		if (jQuery(e.target).closest('.wc-block-components-checkout-place-order-button').length > 0) {
			setCookie('haschecktout', '1', 1);
		}
	});  




	});

function setCookie(name,value,days) {
	if (days) {
		var date = new Date();
		date.setTime(date.getTime()+(days*24*60*60*1000));
		var expires = "; expires="+date.toGMTString();
	}
	else var expires = "";
	document.cookie = name+"="+value+expires+"; path=/";
}
